import { render } from "./userSettings.vue?vue&type=template&id=015b83a6"
import script from "./userSettings.vue?vue&type=script&lang=js"
export * from "./userSettings.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\EZZKAH\\IdeaProjects\\datapark\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__